
import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CommonApiService } from "src/app/services/common-api.service";
import { FetchAIAgentActions } from "./fetch.index";
import { catchError, map, of, switchMap, tap } from "rxjs";
import { API } from "src/app/common/models/api.enum";
import { FetchAiAgent } from "src/app/common/models/ai-agents.model";
import { CommonSignalStore } from "src/app/common/signal-stores/common-store/common.store";
import { encryptData } from "src/app/common/functions/crypto.functions";
import { Router } from "@angular/router";

@Injectable()
export class FetchAIAgentEffects {
    actions = inject(Actions);
    commonApiService = inject(CommonApiService);
    readonly commonStore = inject(CommonSignalStore);
    router = inject(Router);

    fetchAiAgent$ = createEffect(() => {
        return this.actions.pipe(
            ofType(FetchAIAgentActions.fetchAiAgent),
            switchMap((actions) => {                    

                const userId = this.commonStore.loginData()?.data?.userId;
                if (!userId) {
                    return of(FetchAIAgentActions.fetchAiAgentError({ error: 'User Id is required' }));
                }

                let fullURL = API.FETCH_AI_AGENT.replace('{{ userId }}', userId);
                fullURL = fullURL.replace('{{ agentId }}', actions.botId);

                return this.commonApiService.get<FetchAiAgent>(fullURL).pipe(
                    map((response) => {
                        sessionStorage.setItem("aiag", encryptData(response.id));

                        return FetchAIAgentActions.fetchAiAgentSuccess({ response })
                    }),
                    catchError((error) => of(FetchAIAgentActions.fetchAiAgentError({ error })))
                )
            })
        )
    })

    fetchAiAgentClear$ = createEffect(() => {
            return this.actions.pipe(
                ofType(FetchAIAgentActions.fetchAiAgentClear),
                tap(() => {
                    sessionStorage.removeItem("aiag");
                }),
            )
        },
        { dispatch: false }
    )
}
